import { z } from 'zod';

export const rawLinkMetaSchema = z.object({
  meta: z.object({ data: z.string().base64() })
});
